import {createUseStyles} from "react-jss";

export const useStyles = createUseStyles({
	title: {
		//...theme.title
	},
	firstSection:{
		display: "flex",
		marginBottom: 8,
	},
	liveCounter:{
		paddingTop: 12,
		paddingBottom: 12,
		borderRight: "1px solid #eaeaea",
		paddingRight: 12,
		paddingLeft: 8,
		"& > *":{
			textAlign: "center",
		}
	},
	liveBreakpoints:{
		flexGrow: 1,
		paddingLeft: 8,
		paddingRight: 4,
	},
	secondSection: {
	},
	subtitle:{
		//...theme.subtitle
	},
})
